import { Button, buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import React from "react";

interface Props {
	emoji: string;
	description: string;
	href: string;
	link: string;
}
const EmojiLink = ({ emoji, description, link, href }: Props) => {
	return (
		<div className="flex flex-col justify-center items-center w-full text-center">
			<p className="text-[60px]">{emoji}</p>
			<p className="mt-4 mb-8 text-xl">{description}</p>
			<Link
				to={href}
				className={cn(
					buttonVariants({
						variant: "outline",
						size: "lg",
						className: "gap-x-1",
					}),
				)}
			>
				{link} <ArrowRight />
			</Link>
		</div>
	);
};

export default EmojiLink;
